export class FeatureRevisionConstants {
  public static limitCode = "Limit Code";
  public static causeOfLoss = "Cause of Loss";
}
